import { types } from "mobx-state-tree";
import { InputType } from "pages/producer/common/lib/input.types";
import {
    AudioTransitionType,
    DirectionType,
    TransitionType
} from "pages/producer/common/lib/transitions.types";
import { EndMode, SourceProtocol } from "./types";

export const liveStreamTypes = [
    InputType.Live,
    InputType.Local,
    InputType.Guest,
    InputType.GuestScreenShare
];

export const getAudioMixerV1SupportedInputTypes = () => [
    InputType.Guest,
    InputType.Live,
    InputType.Local,
    InputType.MediaPlayer,
    InputType.Vod,
    InputType.Web
];

export const getAudioMixerSupportedInputTypes = () => [
    InputType.Guest,
    InputType.GuestScreenShare,
    InputType.Live,
    InputType.Local,
    InputType.MediaPlayer,
    InputType.Playlist,
    InputType.Vod,
    InputType.Web
];

export const getGuestSupportedInputTypes = () => [
    InputType.Guest,
    InputType.GuestIntercom,
    InputType.GuestScreenShare,
    InputType.Live,
    InputType.MediaPlayer
];

export const endModeType = types.optional(
    types.enumeration(Object.values(EndMode)),
    EndMode.Loop
);

export const Transition = Object.freeze({
    Cut: {
        label: `Cut`,
        value: TransitionType.Cut
    },
    SlideIn: {
        label: `Slide in`,
        value: TransitionType.SlideIn
    },
    SlideOut: {
        label: `Slide Out`,
        value: TransitionType.SlideOut
    },
    Push: {
        label: `Push`,
        value: TransitionType.Push
    },
    BarnDoor: {
        label: `Barn Door`,
        value: TransitionType.BarnDoor
    },
    Wipe: {
        label: `Wipe`,
        value: TransitionType.Wipe
    }
});

export const TransitionOptions = Object.values(Transition);

export const Direction = Object.freeze({
    Right: {
        label: `Right`,
        value: DirectionType.Right
    },
    Left: {
        label: `Left`,
        value: DirectionType.Left
    },
    Up: {
        label: `Up`,
        value: DirectionType.Up
    },
    Down: {
        label: `Down`,
        value: DirectionType.Down
    }
});

export const TransitionDirections = Object.values(Direction);

export const AudioTransition = Object.freeze({
    Crossfade: {
        label: `Crossfade`,
        value: AudioTransitionType.Crossfade
    },
    VFade: {
        label: `V-Fade`,
        value: AudioTransitionType.VFade
    },
    Cut: {
        label: `Cut`,
        value: AudioTransitionType.Cut
    }
});

export const AudioTransitionOptions = Object.values(AudioTransition);

export const SourceProtocolOptions = Object.freeze([
    {
        label: `RTMP`,
        value: SourceProtocol.RTMP
    },
    {
        label: `HLS`,
        value: SourceProtocol.HLS
    },
    {
        label: `SRT (Caller)`,
        value: SourceProtocol.SRT
    }
]);

export const getSourceProtocolOption = (sp: SourceProtocol) =>
    SourceProtocolOptions.find((option) => option.value === sp);

export const VideoAudioDecode = Object.freeze({
    VideoAndAudio: {
        label: `Video and audio`,
        videoDecodingEnabled: true,
        audioDecodingEnabled: true
    },
    Video: {
        label: `Video only`,
        videoDecodingEnabled: true,
        audioDecodingEnabled: false
    },
    Audio: {
        label: `Audio only`,
        videoDecodingEnabled: false,
        audioDecodingEnabled: true
    }
});

export const VideoAudioDecodeOptions = Object.values(VideoAudioDecode);

export const SRT_LATENCY_RANGE = Object.freeze({
    DEFAULT: 2000,
    MIN: 0,
    MAX: 15000
});

export const SRT_PORT_RANGE = Object.freeze({
    MIN: 0,
    MAX: 65535
});

export const REPLAY_DEFAULT_CAMERA_OPTIONS = Object.freeze([
    {
        srcId: `camera1`,
        displayName: `Camera 1`
    },
    {
        srcId: `camera2`,
        displayName: `Camera 2`
    },
    {
        srcId: `camera3`,
        displayName: `Camera 3`
    },
    {
        srcId: `camera4`,
        displayName: `Camera 4`
    }
]);

export const REPLAY_DEFAULT_CAMERA_TABS = Object.values(
    REPLAY_DEFAULT_CAMERA_OPTIONS
);
